import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useEndGamblingSession = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IEndGamblingSessionRequestData) =>
        await send<Types.IEndGamblingSessionRequestData, Types.IEndGamblingSessionResponseData>({
            ID: 35905,
            responses: [35906, 35907],
            description: 'End Gambling Session',
            ...request
        }), [send]);
};
